/* eslint-disable no-case-declarations */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Axios from '../../../axios-proas'
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import { EntOwnersSelect, AddOwner, SearchOwner, SelectOwnersHeader, SelectOwnersItem, SelectOwnersItems, SelectOwnersList, ItemLabel, ItemCode, SelectContainer } from './DropDown.styled';
import { useTranslation } from 'react-i18next';
import { BtnIcon, PrimaryBtnOutlineAction, SearchInput, SearchInputContainer, PrimaryBtnOutlineActionModal, SecondaryBtnOutlineActionModal } from "../../../styles/Common";
import MandatoryMarker from '../../UI/MandatoryMarker';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import DoneIcon from '@mui/icons-material/Done';
import SearchIcon from '@mui/icons-material/Search';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faUser, faDolly, faPersonRays, faUserGear, faCircleInfo, faCirclePlus } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';

function DropDownPermission({ estGestionAdresse, updatePermissions, permissions, roles }) {
    const [permissionsByRoles, setPermissionsByRoles] = useState([]);
    const { t } = useTranslation();
    const [showEntityModal, setShowEntityModal] = useState(false);
    const [searchQuery, setSearchQuery] = useState(null)
    const [items, setItems] = useState()


        useEffect(() => {
            if (roles?.some((role) => ["Bailleur", "BailleurAdministrateur"].includes(role))) {
                let tab = [
                    { claimType: "permissions", claimValue: "AjoutJustificatif" },
                    { claimType: "permissions", claimValue: "GestionDerive" },

                ];
                if (estGestionAdresse) {
                    tab.push({ claimType: "permissions", claimValue: "ModificationAdresse" })
                }
                setPermissionsByRoles(tab)
            } else {
                let permissionsTemp = [];

                if (roles?.some((role) => ["OperateurBackOfficeInterne","OperateurBackOfficeExterne"].includes(role))) {
                    permissionsTemp.push(                   
                        { claimType: "permissions", claimValue: "ModificationAdresse" },
                        { claimType: "permissions", claimValue: "Saisie" },
                        { claimType: "permissions", claimValue: "AjoutJustificatif" },
                        { claimType: "permissions", claimValue: "ControleNiveau1" },
                        { claimType: "permissions", claimValue: "RenvoiEnquetePapier" }
                    )
                }

                if (roles?.some((role) => ["OperateurBackOfficeInterne"].includes(role))) {
                    permissionsTemp.push(
                        { claimType: "permissions", claimValue: "ControleNiveau2"}, 
                        { claimType: "permissions", claimValue: "Exploitation"},
                        { claimType: "permissions", claimValue: "PilotageNiveau1"},
                        { claimType: "permissions", claimValue: "PilotageNiveau2"})
                }
                setPermissionsByRoles(permissionsTemp)
            }
            setItems(permissions)
         
        }, [roles, permissions])

   



    const SelectEntity = (entity) => {
        let selectedTemp = [...items];
        switch (entity.claimValue) {
            case "GestionDerive":             
                let ajoutJustificatifIndex = items?.findIndex(row => row.claimValue === "AjoutJustificatif");
                if (ajoutJustificatifIndex < 0) {
                    let p = { claimType: "permissions", claimValue: "AjoutJustificatif" };
                    selectedTemp.push(p);
                }
                selectedTemp.push(entity) 
                setItems(selectedTemp)
                break;
          
            default:
                let entityIndex = items?.findIndex(row => row.claimValue === entity.claimValue);
               
                if (entityIndex < 0)
                    selectedTemp = [...items, entity];
                setItems(selectedTemp)
              
        }

    }

    const deleteItem = (entity) => {
        let selectedTemp = [...items];
        switch (entity.claimValue) {
            case "AjoutJustificatif":
               
                let gestionDeriveIndex = items?.findIndex(row => row.claimValue === "GestionDerive");
                if (gestionDeriveIndex >= 0) {
                    selectedTemp.splice(gestionDeriveIndex, 1)                 
                }
                let ajoutJustificatifIndex = items.findIndex(ent => ent.claimValue === entity.claimValue);
                if (ajoutJustificatifIndex >= 0) {
                    selectedTemp.splice(ajoutJustificatifIndex, 1)
                }
                setItems(selectedTemp)
                break;

            default:
                let entityIndex = items.findIndex(ent => ent.claimValue === entity.claimValue);
                if (entityIndex >= 0) {
                    selectedTemp.splice(entityIndex, 1)
                }
                setItems(selectedTemp)

        }    

    }





    return (
        <>

            <AddOwner >
                <FontAwesomeIcon icon={faCirclePlus} style={{ color: "#2174b980", fontSize: "1rem", paddingTop: "2px" }} onClick={() => setShowEntityModal(!showEntityModal)} />
                {
                    showEntityModal && (
                        <SelectContainer>
                           
                            <SelectOwnersList>
                                <SelectOwnersHeader>
                                    {/* <span>Raison sociale</span>
                            <span>Code</span> */}
                                </SelectOwnersHeader>
                                <SelectOwnersItems>
                                    {
                                        permissionsByRoles?.length > 0 ? permissionsByRoles.map(entity => (
                                            <SelectOwnersItem key={entity?.roleId} >
                                                <input type='checkbox' disabled={entity?.disabled || false} name={entity.claimValue} checked={items?.findIndex(row => row.claimValue === entity.claimValue) >= 0} style={{ marginRight: '0.5rem' }}
                                                    onChange={(e) => {
                                                        items?.findIndex(row => row.claimValue === entity.claimValue) >= 0 ? deleteItem(entity) : SelectEntity(entity)
                                                    }}
                                                />
                                                <ItemLabel>{entity?.claimValue}</ItemLabel>
                                          
                                            </SelectOwnersItem>
                                        )) : <div style={{ whiteSpace: "nowrap" }}>
                                            {t('mandat:noAgencies', "Aucune donneé à afficher")}
                                        </div>
                                    }
                                </SelectOwnersItems>

                                <div style={{ display: "flex", justifyContent: "center", width: "auto" }}>
                                    <PrimaryBtnOutlineActionModal>
                                        <DoneIcon onClick={e => { updatePermissions(items), setShowEntityModal(false) }} />
                                    </PrimaryBtnOutlineActionModal>

                                    <SecondaryBtnOutlineActionModal>
                                        <CloseIcon onClick={e => setShowEntityModal(false)} />
                                    </SecondaryBtnOutlineActionModal>

                                </div>

                            </SelectOwnersList>

                        </SelectContainer>

                    )
                }
            </AddOwner>



        </>
    );
}

export default DropDownPermission;



